module.exports = __webpack_public_path__ + "img/CL.75d82459.svg";